import { useParams } from "react-router-dom";
import { getLocalStorageData } from "../../utils/LocalStorageService";
import { useDispatch } from "react-redux";
import { useEffect, useState } from "react";
import { ACTION_TYPE, REPORT_NAME, REPORT_PATH } from "../constant/reportType";
import { Switch, Table } from "antd";
import {
    CARBON_PROJECT_MASTER_COLUMN,
    CARBON_SOURCE_MASTER_COLUMN,
    MONITORING_BATCH_COLUMN,
    VERIFICATION_RECORD_COLUMN,
} from "../constant/AppConstant";
import { BsPlus, BsSearch, BsPencilSquare } from "react-icons/bs";
import { alertMessage } from "../../utils/AlertService";
import { useAppSelector } from "../../redux-toolkit/hooks";
import Loading from "../Loading";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";

import {
    useDeleteCarbonSourceMasterMutation,
    useGetAllCarbonSourceMasterMutation,
} from "../../redux-toolkit/services/carbonSourceMasterService";
import {
    useDeleteMonitoringBatchMutation,
    useGetAllMonitoringBatchMutation,
} from "../../redux-toolkit/services/monitoringBatchService";
import {
    useDeleteVerificationRecordMutation,
    useGetAllVerificationRecordMutation,
} from "../../redux-toolkit/services/verificationRecordService";
import {
    useGetAllProjectsMutation,
    useDeleteProjectMutation,
} from "../../redux-toolkit/services/projectIntegrationService";

import {
    getAllCarbonSourceMasterDetails,
    getCarbonSourceMasterTotalRecords,
    setCarbonSourceMaster,
} from "../../redux-toolkit/slices/carbonSourceMasterSlice";
import {
    getAllMonitoringBatchDetails,
    getMonitoringBatchTotalRecords,
    setMonitoringBatch,
} from "../../redux-toolkit/slices/monitoringBatchSlice";
import {
    getAllVerificationRecordDetails,
    getVerificationRecordTotalRecords,
    setVerificationRecord,
} from "../../redux-toolkit/slices/verificationRecordSlice";
import {
    getAllProjectDetails,
    getProjectTotalRecords,
    setProjectIntegration,
} from "../../redux-toolkit/slices/projectIntegrationSlice";

import CarbonMasterData from "./CarbonMasterData";

type Props = {};

const CarbonMaster = (props: Props) => {
    const params = useParams();
    const dispatch = useDispatch();
    const localUserObj: any = getLocalStorageData("localUser");

    // state
    const [actionType, setActionType] = useState<ACTION_TYPE>(ACTION_TYPE.ADD_ACTION);
    const [reportName, setReportName]: any = useState();
    const [currentpage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [show, setShow] = useState(false);
    const [selectedRow, setSelectedRow]: any = useState([]);
    const [columData, setColumnData]: any = useState();
    const [dataSource, setDatasource]: any = useState([]);
    const [call, setCall] = useState("N");
    const [searchTerm, setSearchTerm] = useState("");
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [selectedRecord, setSelectedRecord] = useState<any>(null);

    // getMutations
    const [getAllCarbonSourceMaster, allCarbonSourceMasterResponse] = useGetAllCarbonSourceMasterMutation();
    const [getAllMonitoringBatch, allMonitoringBatchResponse] = useGetAllMonitoringBatchMutation();
    const [getAllVerificationRecord, allVerificationRecordResponse] = useGetAllVerificationRecordMutation();

    // delete mutations
    const [deleteCarbonSourceMaster, deleteCarbonSourceMasterResponse] = useDeleteCarbonSourceMasterMutation();
    const [deleteMonitoringBatch, deleteMonitoringBatchResponse] = useDeleteMonitoringBatchMutation();
    const [deleteVerificationRecord, deleteVerificationRecordResponse] = useDeleteVerificationRecordMutation();
    const [deleteProject, deleteProjectResponse] = useDeleteProjectMutation();
    const [getAllProjects, allProjectsResponse] = useGetAllProjectsMutation();

    // totalRecords
    const totalCarbonSourceMaster: any = useAppSelector(getCarbonSourceMasterTotalRecords);
    const totalMonitoringBatch: any = useAppSelector(getMonitoringBatchTotalRecords);
    const totalVerificationRecord: any = useAppSelector(getVerificationRecordTotalRecords);
    const totalProjects: any = useAppSelector(getProjectTotalRecords);

    // selectors
    const allCarbonSourceMaster: any = useAppSelector(getAllCarbonSourceMasterDetails);
    const allMonitoringBatch: any = useAppSelector(getAllMonitoringBatchDetails);
    const allVerificationRecord: any = useAppSelector(getAllVerificationRecordDetails);
    const allProjects: any = useAppSelector(getAllProjectDetails);

    useEffect(() => {
        switch (params.reportType) {
            case REPORT_PATH.CARBON_PROJECT_MASTER:
                setReportName(REPORT_NAME.CARBON_PROJECT_MASTER);
                break;
            case REPORT_PATH.CARBON_SOURCE_MASTER:
                setReportName(REPORT_NAME.CARBON_SOURCE_MASTER);
                break;
            case REPORT_PATH.MONITORING_BATCH:
                setReportName(REPORT_NAME.MONITORING_BATCH);
                break;
            case REPORT_PATH.VERIFICATION_RECORD:
                setReportName(REPORT_NAME.VERIFICATION_RECORD);
                break;
            default:
        }
    }, [params.reportType]);


    // Build columns with action
    useEffect(() => {
        const temp: any = [];
        const tempAction: any = {
            title: "Action",
            dataIndex: "action",
            key: "action",
            fixed: "right",
            width: 150,
            render: (index: any, record: any) => {
                return (
                    <div className="d-flex justify-content-between">
                        <div className="px-2 pe-auto">
                            <Switch
                                className={`${record.status === true ? "bg-accent" : "bg-secondry"}`}
                                checked={record.status === true}
                                onChange={() => {
                                    if (record.status === true) {
                                        setSelectedRecord(record);
                                        setShowDeleteModal(true);
                                    } else {
                                        onDeleteData(record, "activate");
                                    }
                                }}
                            />
                        </div>
                        {record.status === true ? (
                            <div
                                className="px-2 pe-auto cursor-pointer"
                                onClick={() => {
                                    handleOpenForm(record);
                                }}
                            >
                                <BsPencilSquare size={18} />
                            </div>
                        ) : null}
                    </div>
                );
            },
        };

        if (reportName === REPORT_NAME.CARBON_PROJECT_MASTER && CARBON_PROJECT_MASTER_COLUMN) {
            CARBON_PROJECT_MASTER_COLUMN.forEach((item: any) => temp.push(item));
            temp.push(tempAction);
            setColumnData(temp);
        } else if (reportName === REPORT_NAME.CARBON_SOURCE_MASTER && CARBON_SOURCE_MASTER_COLUMN) {
            CARBON_SOURCE_MASTER_COLUMN.forEach((item: any) => temp.push(item));
            temp.push(tempAction);
            setColumnData(temp);
        } else if (reportName === REPORT_NAME.MONITORING_BATCH && MONITORING_BATCH_COLUMN) {
            MONITORING_BATCH_COLUMN.forEach((item: any) => temp.push(item));
            temp.push(tempAction);
            setColumnData(temp);
        } else if (reportName === REPORT_NAME.VERIFICATION_RECORD && VERIFICATION_RECORD_COLUMN) {
            VERIFICATION_RECORD_COLUMN.forEach((item: any) => temp.push(item));
            temp.push(tempAction);
            setColumnData(temp);
        }
    }, [reportName, params.reportType]);

    // Initial fetch
    const fetchData = (page: number, size: number) => {
        if (reportName === REPORT_NAME.CARBON_PROJECT_MASTER) {
            getAllProjects({
                token: localUserObj?.token,
                page: page - 1,
                offset: size,
            });
        } else if (reportName === REPORT_NAME.CARBON_SOURCE_MASTER) {
            getAllCarbonSourceMaster({
                token: localUserObj?.token,
                payload: { pageNumber: page - 1, offset: size },
            });
        } else if (reportName === REPORT_NAME.MONITORING_BATCH) {
            getAllMonitoringBatch({
                token: localUserObj?.token,
                page: page - 1,
                size: size,
            });
        } else if (reportName === REPORT_NAME.VERIFICATION_RECORD) {
            getAllVerificationRecord({
                token: localUserObj?.token,
                page: page - 1,
                size: size,
            });
        }
    };

    useEffect(() => {
        if (reportName) fetchData(currentpage, pageSize);
    }, [reportName]);

    useEffect(() => {
        if (call === "Y") {
            fetchData(currentpage, pageSize);
            setCall("N");
        }
    }, [call]);

    const paginationChange = (page: number, size: number) => {
        setCurrentPage(page);
        setPageSize(size);
        if (reportName === REPORT_NAME.CARBON_PROJECT_MASTER) {
            getAllProjects({ token: localUserObj?.token, page: page - 1, offset: size });
        } else if (reportName === REPORT_NAME.CARBON_SOURCE_MASTER) {
            getAllCarbonSourceMaster({
                token: localUserObj?.token,
                payload: { pageNumber: page - 1, offset: size },
            });
        } else if (reportName === REPORT_NAME.MONITORING_BATCH) {
            getAllMonitoringBatch({ token: localUserObj?.token, page: page - 1, size });
        } else if (reportName === REPORT_NAME.VERIFICATION_RECORD) {
            getAllVerificationRecord({ token: localUserObj?.token, page: page - 1, size });
        }
    };

    const handleShow = () => {
        setActionType(ACTION_TYPE.ADD_ACTION);
        setSelectedRow({});
        setShow(true);
    };

    const getRecordName = () => {
        if (reportName === REPORT_NAME.CARBON_PROJECT_MASTER) return "Carbon Project";
        if (reportName === REPORT_NAME.CARBON_SOURCE_MASTER) return "Carbon Source";
        if (reportName === REPORT_NAME.MONITORING_BATCH) return "Monitoring Batch";
        if (reportName === REPORT_NAME.VERIFICATION_RECORD) return "Verification Record";
        return reportName;
    };

    const onDeleteData = (
        record: any,
        type: "soft" | "hard" | "activate"
    ) => {

        let mutationPromise: any;

        if (reportName === REPORT_NAME.CARBON_PROJECT_MASTER) {
            mutationPromise = deleteProject({
                token: localUserObj?.token,
                id: record.id,
                type: type,
            });

        } else if (reportName === REPORT_NAME.CARBON_SOURCE_MASTER) {

            mutationPromise = deleteCarbonSourceMaster({
                token: localUserObj?.token,
                id: record.id,
                type: type,
            });

        } else if (reportName === REPORT_NAME.MONITORING_BATCH) {

            mutationPromise = deleteMonitoringBatch({
                token: localUserObj?.token,
                id: record.id,
                type: type,
            });

        } else if (reportName === REPORT_NAME.VERIFICATION_RECORD) {

            mutationPromise = deleteVerificationRecord({
                token: localUserObj?.token,
                id: record.id,
                type: type,
            });
        }

        if (mutationPromise) {
            mutationPromise.unwrap()
                .then(() => {
                    const recName = getRecordName();
                    if (type === "hard") {
                        alertMessage(`${recName} deleted permanently`, "success");
                        setDatasource((prev: any) => prev.filter((item: any) => item.id !== record.id));
                    } else if (type === "soft") {

                        setDatasource((prev: any) =>
                            prev.map((item: any) =>
                                item.id === record.id
                                    ? { ...item, status: false }
                                    : item
                            )
                        );

                        alertMessage(`${recName} deleted successfully`, "success");
                        setCall("Y");

                    } else if (type === "activate") {

                        setDatasource((prev: any) =>
                            prev.map((item: any) =>
                                item.id === record.id
                                    ? { ...item, status: true }
                                    : item
                            )
                        );

                        alertMessage(`${recName} activated successfully`, "success");
                        setCall("Y");
                    }
                })
                .catch((error: any) => {
                    const errorMsg = error?.data?.message || "Cannot delete this record because it is associated with other records";
                    alertMessage(errorMsg, "error");
                });
        }
    };

    const handleSoftDelete = () => {
        setShowDeleteModal(false);
        if (selectedRecord) {
            onDeleteData(selectedRecord, "soft");
        }
    };

    const handleHardDelete = () => {
        setShowDeleteModal(false);
        if (selectedRecord) {
            onDeleteData(selectedRecord, "hard");
        }
    };

    const handleOpenForm = (record: any) => {
        setActionType(ACTION_TYPE.UPDATE_ACTION);
        setSelectedRow(record);
        setShow(true);
    };

    // API response dispatch effects
    useEffect(() => {
        if (allProjectsResponse.isSuccess) {
            dispatch(setProjectIntegration(allProjectsResponse));
        } else if (allProjectsResponse.isError) {
            alertMessage(allProjectsResponse.error as any, "error");
        }
    }, [allProjectsResponse.isSuccess, allProjectsResponse.isError]);

    useEffect(() => {
        if (allCarbonSourceMasterResponse.isSuccess) {
            dispatch(setCarbonSourceMaster(allCarbonSourceMasterResponse));
        } else if (allCarbonSourceMasterResponse.isError) {
            alertMessage(allCarbonSourceMasterResponse.error as any, "error");
        }
    }, [allCarbonSourceMasterResponse.isSuccess, allCarbonSourceMasterResponse.isError]);

    useEffect(() => {
        if (allMonitoringBatchResponse.isSuccess) {
            dispatch(setMonitoringBatch(allMonitoringBatchResponse));
        } else if (allMonitoringBatchResponse.isError) {
            alertMessage(allMonitoringBatchResponse.error as any, "error");
        }
    }, [allMonitoringBatchResponse.isSuccess, allMonitoringBatchResponse.isError]);

    useEffect(() => {
        if (allVerificationRecordResponse.isSuccess) {
            dispatch(setVerificationRecord(allVerificationRecordResponse));
        } else if (allVerificationRecordResponse.isError) {
            alertMessage(allVerificationRecordResponse.error as any, "error");
        }
    }, [allVerificationRecordResponse.isSuccess, allVerificationRecordResponse.isError]);

    // Data binding effects
    useEffect(() => {
        if (allProjects && reportName === REPORT_NAME.CARBON_PROJECT_MASTER) {
            setDatasource(Array.isArray(allProjects) ? allProjects : []);
        }
    }, [allProjects]);

    useEffect(() => {
        if (allCarbonSourceMaster && reportName === REPORT_NAME.CARBON_SOURCE_MASTER) {
            setDatasource(Array.isArray(allCarbonSourceMaster) ? allCarbonSourceMaster : []);
        }
    }, [allCarbonSourceMaster]);

    useEffect(() => {
        if (allMonitoringBatch && reportName === REPORT_NAME.MONITORING_BATCH) {
            setDatasource(Array.isArray(allMonitoringBatch) ? allMonitoringBatch : []);
        }
    }, [allMonitoringBatch]);

    useEffect(() => {
        if (allVerificationRecord && reportName === REPORT_NAME.VERIFICATION_RECORD) {
            setDatasource(Array.isArray(allVerificationRecord) ? allVerificationRecord : []);
        }
    }, [allVerificationRecord]);

    const getTotalRecords = () => {
        if (reportName === REPORT_NAME.CARBON_PROJECT_MASTER) return totalProjects;
        if (reportName === REPORT_NAME.CARBON_SOURCE_MASTER) return totalCarbonSourceMaster;
        if (reportName === REPORT_NAME.MONITORING_BATCH) return totalMonitoringBatch;
        if (reportName === REPORT_NAME.VERIFICATION_RECORD) return totalVerificationRecord;
        return 0;
    };

    const isLoading =
        allProjectsResponse.isLoading ||
        allCarbonSourceMasterResponse.isLoading ||
        allMonitoringBatchResponse.isLoading ||
        allVerificationRecordResponse.isLoading ||
        deleteProjectResponse.isLoading ||
        deleteCarbonSourceMasterResponse.isLoading ||
        deleteMonitoringBatchResponse.isLoading ||
        deleteVerificationRecordResponse.isLoading;

    return (
        <div className="mt-2 overflow-y-auto">
            {/* Modal rendered at top level, outside toolbar */}
            {show && (
                <CarbonMasterData
                    show={show}
                    setShow={setShow}
                    actionType={actionType}
                    reportName={reportName}
                    data={selectedRow}
                    setCall={setCall}
                />
            )}

            <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)} centered>
                <Modal.Body className="text-center pb-0 mt-3">
                    <h5 className="mb-4">Do you want to delete this record permanently?</h5>
                </Modal.Body>
                <Modal.Footer className="border-0 justify-content-center mb-2">
                    <Button variant="danger" onClick={handleHardDelete}>
                        Yes
                    </Button>
                    <Button variant="secondary" onClick={handleSoftDelete}>
                        No
                    </Button>
                </Modal.Footer>
            </Modal>

            <div className="d-flex align-items-center justify-content-between flex-sm-row flex-column mb-2">
                <div className="d-flex align-items-center w-100 px-2">
                    <h5
                        className="m-0 px-0 d-flex align-items-center text-accent"
                        style={{ fontWeight: "700" }}
                    >
                        {reportName}
                    </h5>
                </div>
                <div
                    className="d-flex align-items-center justify-content-start justify-content-sm-end cursor-pointer w-100 flex-wrap"
                    style={{ gap: "8px" }}
                >
                    <div className="d-flex flex-column" style={{ minWidth: "200px" }}>
                        <div className="input-group px-2 mt-1">
                            <Form.Control
                                type="search"
                                placeholder="Search"
                                className="border-0 bg-cm-light-primary1"
                                aria-label="Search"
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                            />
                            <div className="input-group-append bg-cm-light-primary1 p-1 rounded-end">
                                <span className="input-group-text bg-cm-light-primary1 border-0">
                                    <BsSearch className="bg-cm-light-primary1 border-cm-light-primary1" />
                                </span>
                            </div>
                        </div>
                    </div>

                    <div className="d-flex px-2 align-items-center mt-1">
                        <Button
                            className="d-flex align-items-center me-0 text-nowrap bg-accent border-0"
                            onClick={handleShow}
                        >
                            <BsPlus />
                            Add
                        </Button>
                    </div>

                    {isLoading && <Loading />}
                </div>
            </div>

            <div className="mt-3 my-2 w-100 overflow-x-auto rounded-3">
                <Table
                    bordered={true}
                    rowKey={"id"}
                    scroll={{ x: "max-content" }}
                    tableLayout="fixed"
                    pagination={{
                        total: getTotalRecords(),
                        responsive: true,
                        current: currentpage,
                        pageSizeOptions: [10, 20, 30],
                        onChange: (page, pageSize) => {
                            paginationChange(page, pageSize);
                        },
                        pageSize: pageSize,
                    }}
                    columns={columData}
                    dataSource={dataSource}
                />
            </div>
        </div>
    );
};

export default CarbonMaster;
